const config = {
    BACKEND_URI: process.env.NEXT_PUBLIC_BACKEND_URI,
    PORTAL_BACKEND_URI: process.env.NEXT_PUBLIC_PORTAL_BACKEND_URI,
    UPLOAD_URI: process.env.NEXT_PUBLIC_UPLOAD_URI,
    TICKET_URI: process.env.NEXT_PUBLIC_TICKET_URI,
    COOKIE_PREFIX: process.env.NEXT_PUBLIC_COOKIE_PREFIX,
    RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? "",
    GOOGLE_MAPS_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
    ACCEPT_SCRIPT_SRC: process.env.NEXT_PUBLIC_ACCEPT_SCRIPT_SRC,
    SONGBIRD_SCRIPT_SRC: process.env.NEXT_PUBLIC_SONGBIRD_SCRIPT_SRC,
    PUBLIC_URL: process.env.NEXT_PUBLIC_BASE_URL,
};

export default config;
